import React from 'react';
import { CSSObject } from '@emotion/react';
import { useTranslate } from 'nucleus-text';
import { injectTestId } from '@cvent/nucleus-test-automation';
import { useThemeValues } from '@context/ThemeProvider';
import Typography from '@cvent/blocks/components/Typography';
import EmptyNotificationFlyoutSVG from './EmptyNotificationSVG';

const useStyles = (hideIllustrations): Record<string, CSSObject> => ({
  bodyText: {
    textAlign: 'center',
    paddingTop: hideIllustrations ? 72 : 0
  }
});
type Props = {
  testID: string;
};

/**
 * Component for rendering empty screen if no notifications are present
 */
function EmptyContainer({ testID }: Props): JSX.Element {
  const { hideIllustrations } = useThemeValues();
  const styles = useStyles(hideIllustrations);
  const { translate } = useTranslate();
  return (
    <div {...injectTestId(`${testID}-container`)}>
      {!hideIllustrations && (
        <div css={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <EmptyNotificationFlyoutSVG testID="empty-notification-image" />
        </div>
      )}
      <Typography as="h3" styledAs="h4" css={styles.bodyText}>
        {translate('Notifications-Empty-Message')}
      </Typography>
    </div>
  );
}

export default EmptyContainer;
